import { environment } from '../../environments/environment';

//Comet
export class Constants {
  static readonly appName = "Kyper Shift";
  static readonly deepLinkURL =  environment.actionDeepLinkURL;
  static readonly packageId = "com.cometpro.cometpro";
  static readonly deepLinkRouter = environment.deepLinkRouter;
  static readonly branchUriScheme = environment.brachURIScheme
  static readonly pathGroupName = "Comet Demo";
  static readonly appLogoPath = "../../assets/icon/kyper-shift-login-logo.png";
  static readonly prodWebappUrl = "https://kypershift.1st90.com/login"; 
  static readonly branchLink = environment.branchKey;
}
